/* ==========================================================================
   NONFILTERD theme v4 — vanilla JS, no dependencies
   Announcement rotator, search panel, drawers, ajax cart, bag timer, quick add, upsell slider, product page, size guide, load more, email popup
   ========================================================================== */
(function () {
  'use strict';

  var doc = document;
  var root = doc.documentElement;
  var NF = window.NF || {};
  var routes = NF.routes || { root: '/', cart: '/cart', cartAdd: '/cart/add.js', cartChange: '/cart/change.js' };
  var SECTION = 'cart-drawer';
  var cookieClosedAt = 0; /* set when the cookie window closes; the email popup waits a few seconds after it */
  function cookieRecentlyClosed() { return !!cookieClosedAt && Date.now() - cookieClosedAt < 6000; }

  function $(sel, ctx) { return (ctx || doc).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || doc).querySelectorAll(sel)); }

  /* ------------------------------------------------------------------ toast */
  function toast(message) {
    var el = doc.createElement('div');
    el.className = 'toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    doc.body.appendChild(el);
    window.setTimeout(function () { el.classList.add('is-in'); }, 10);
    window.setTimeout(function () {
      el.classList.remove('is-in');
      window.setTimeout(function () { if (el.parentNode) el.parentNode.removeChild(el); }, 300);
    }, 3600);
  }

  /* ---------------------------------------------------------------- drawers */
  var returnFocus = null;

  function openDrawer(el) {
    if (!el) return;
    returnFocus = doc.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    root.classList.add('has-drawer');
    $$('[data-drawer-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
    var panel = $('.drawer__panel', el);
    if (panel) window.setTimeout(function () { panel.focus({ preventScroll: true }); }, 40);
  }

  function closeDrawer(el) {
    if (!el || !el.classList.contains('is-open')) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    $$('[data-drawer-open="' + el.id + '"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (!$('.drawer.is-open')) root.classList.remove('has-drawer');
    if (returnFocus && returnFocus.focus) {
      try { returnFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
    }
  }

  function openCart() { openDrawer(doc.getElementById('CartDrawer')); }

  /* ----------------------------------------------------------- search panel */
  function setSearch(open) {
    var panel = $('[data-search-panel]');
    if (!panel) return;
    panel.hidden = !open;
    $$('[data-search-toggle]').forEach(function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
    if (open) {
      var input = $('[data-search-input]', panel);
      if (input) window.setTimeout(function () { input.focus(); }, 30);
    }
  }

  doc.addEventListener('keydown', function (e) {
    var panel = $('[data-search-panel]');
    if (e.key === 'Escape' && panel && !panel.hidden) {
      setSearch(false);
      var tg = $('[data-search-toggle]');
      if (tg) tg.focus();
      return;
    }
    var open = $$('.drawer.is-open');
    if (!open.length) return;
    var top = open[open.length - 1];
    if (e.key === 'Escape') { closeDrawer(top); return; }
    if (e.key === 'Tab') {
      var focusables = $$('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select, textarea, summary, [tabindex]:not([tabindex="-1"])', top)
        .filter(function (n) { return n.offsetParent !== null; });
      if (!focusables.length) return;
      var first = focusables[0];
      var last = focusables[focusables.length - 1];
      if (e.shiftKey && (doc.activeElement === first || doc.activeElement === top.querySelector('.drawer__panel'))) {
        e.preventDefault(); last.focus();
      } else if (!e.shiftKey && doc.activeElement === last) {
        e.preventDefault(); first.focus();
      }
    }
  });

  /* ------------------------------------------------------------------- cart */
  function request(url, options) {
    return fetch(url, options).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok) {
          var err = new Error((data && (data.description || data.message)) || 'Something went wrong. Please try again.');
          err.data = data;
          throw err;
        }
        return data;
      });
    });
  }

  function postJSON(url, payload) {
    return request(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(payload)
    });
  }

  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; });
  }

  function renderDrawer(sections) {
    var html = sections && sections[SECTION];
    var current = $('[data-cart-drawer-inner]');
    if (!html || !current) return false;
    var next = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-drawer-inner]');
    if (!next) return false;
    current.innerHTML = next.innerHTML;
    current.setAttribute('data-item-count', next.getAttribute('data-item-count') || '0');
    setCount(next.getAttribute('data-item-count') || 0);
    cartTimer.sync(false);
    return true;
  }

  function refreshCart() {
    return request(routes.root + '?sections=' + SECTION, { headers: { 'Accept': 'application/json' } })
      .then(function (sections) { renderDrawer(sections); });
  }

  function addToCart(id, quantity) {
    return postJSON(routes.cartAdd, {
      items: [{ id: Number(id), quantity: quantity || 1 }],
      sections: SECTION,
      sections_url: window.location.pathname
    }).then(function (data) {
      if (!renderDrawer(data.sections)) return refreshCart();
    }).then(function () {
      cartTimer.sync(true);
      if (doc.getElementById('CartDrawer')) openCart();
      else window.location.href = routes.cart;
    });
  }

  function showCartError(message) {
    var box = $('[data-cart-error]');
    if (!box) { toast(message); return; }
    box.textContent = message;
    box.hidden = false;
  }

  function changeLine(key, quantity) {
    var inner = $('[data-cart-drawer-inner]');
    if (inner) inner.classList.add('is-loading');
    return postJSON(routes.cartChange, {
      id: key,
      quantity: quantity,
      sections: SECTION,
      sections_url: window.location.pathname
    }).then(function (cart) {
      if (!renderDrawer(cart.sections)) return refreshCart();
    }).catch(function (err) {
      showCartError(err.message);
    }).then(function () {
      var again = $('[data-cart-drawer-inner]');
      if (again) again.classList.remove('is-loading');
    });
  }

  /* --------------------------------------------------------------- clicks */
  doc.addEventListener('click', function (e) {
    var t = e.target;

    /* search panel in the header */
    var searchToggle = t.closest('[data-search-toggle]');
    if (searchToggle) {
      var sp = $('[data-search-panel]');
      setSearch(sp ? sp.hidden : false);
      return;
    }
    var openPanel = $('[data-search-panel]');
    if (openPanel && !openPanel.hidden && !t.closest('[data-search-panel]')) setSearch(false);

    /* size guide dialog on the product page */
    var guideOpen = t.closest('[data-sizeguide-open]');
    if (guideOpen) {
      var guide = $('[data-sizeguide]');
      if (guide && typeof guide.showModal === 'function') { e.preventDefault(); guide.showModal(); }
      return;
    }
    var guideClose = t.closest('[data-sizeguide-close]');
    if (guideClose) {
      var gd = guideClose.closest('dialog');
      if (gd) gd.close();
      return;
    }
    if (t.matches && t.matches('dialog[data-sizeguide]')) { t.close(); return; }

    /* "Want another?" slider arrows in the bag */
    var slideBtn = t.closest('[data-slider-prev], [data-slider-next]');
    if (slideBtn) {
      var box = slideBtn.closest('.cart-upsell');
      var track = box && $('[data-slider]', box);
      if (track) {
        var dir = slideBtn.hasAttribute('data-slider-next') ? 1 : -1;
        if (track.scrollBy) track.scrollBy({ left: dir * track.clientWidth * 0.8, behavior: 'smooth' });
        else track.scrollLeft += dir * track.clientWidth * 0.8;
      }
      return;
    }

    var opener = t.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(doc.getElementById(opener.getAttribute('data-drawer-open')));
      return;
    }

    var closer = t.closest('[data-drawer-close]');
    if (closer) { closeDrawer(closer.closest('.drawer')); return; }

    var bag = t.closest('[data-cart-open]');
    if (bag && !NF.onCartPage && doc.getElementById('CartDrawer')) {
      e.preventDefault();
      openCart();
      return;
    }

    var step = t.closest('[data-cart-step]');
    if (step) {
      e.preventDefault();
      changeLine(step.getAttribute('data-key'), parseInt(step.getAttribute('data-qty'), 10) || 0);
      return;
    }

    /* quick add: open the size picker on a card */
    var toggle = t.closest('[data-quick-toggle]');
    if (toggle) {
      var card = toggle.closest('.card');
      var panel = card && $('[data-quick-panel]', card);
      if (!panel) return;
      var willOpen = !panel.classList.contains('is-open');
      $$('[data-quick-panel].is-open').forEach(function (p) {
        p.classList.remove('is-open');
        var b = $('[data-quick-toggle]', p.closest('.card'));
        if (b) b.setAttribute('aria-expanded', 'false');
      });
      if (willOpen) {
        panel.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      }
      return;
    }

    var qclose = t.closest('[data-quick-close]');
    if (qclose) {
      var qp = qclose.closest('[data-quick-panel]');
      if (qp) {
        qp.classList.remove('is-open');
        var qb = $('[data-quick-toggle]', qp.closest('.card'));
        if (qb) { qb.setAttribute('aria-expanded', 'false'); qb.focus(); }
      }
      return;
    }

    var chip = t.closest('[data-quick-variant]');
    var direct = t.closest('[data-quick-add]');
    var addEl = chip || direct;
    if (addEl && !addEl.disabled) {
      e.preventDefault();
      var variantId = chip ? chip.getAttribute('data-quick-variant') : direct.getAttribute('data-quick-add');
      var host = addEl.closest('.card') || addEl.closest('.up-card');
      if (host) host.classList.add('is-adding');
      addToCart(variantId, 1).then(function () {
        var open = addEl.closest('[data-quick-panel]');
        if (open) open.classList.remove('is-open');
      }).catch(function (err) {
        toast(err.message);
      }).then(function () {
        if (host && host.isConnected) host.classList.remove('is-adding');
      });
      return;
    }

    /* quantity steppers (product page + cart page) */
    var qstep = t.closest('[data-qty-step]');
    if (qstep) {
      var wrap = qstep.closest('[data-qty]');
      var input = wrap && $('input', wrap);
      if (!input) return;
      var min = input.getAttribute('min') !== null ? parseInt(input.getAttribute('min'), 10) : 1;
      var value = (parseInt(input.value, 10) || 0) + parseInt(qstep.getAttribute('data-qty-step'), 10);
      input.value = Math.max(min, value);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    /* load more */
    var more = t.closest('[data-load-more-link]');
    if (more) {
      e.preventDefault();
      if (more.getAttribute('aria-busy') === 'true') return;
      var label = more.textContent;
      more.setAttribute('aria-busy', 'true');
      more.textContent = 'Loading…';
      fetch(more.href).then(function (res) { return res.text(); }).then(function (html) {
        var next = new DOMParser().parseFromString(html, 'text/html');
        var grid = $('[data-product-grid]');
        var nextGrid = $('[data-product-grid]', next);
        if (grid && nextGrid) {
          Array.prototype.slice.call(nextGrid.children).forEach(function (child) {
            grid.appendChild(doc.importNode(child, true));
          });
        }
        var wrapEl = more.closest('[data-load-more]');
        var nextWrap = $('[data-load-more]', next);
        if (wrapEl) {
          if (nextWrap) wrapEl.innerHTML = nextWrap.innerHTML; else wrapEl.parentNode.removeChild(wrapEl);
        }
      }).catch(function () {
        more.removeAttribute('aria-busy');
        more.textContent = label;
        window.location.href = more.href;
      });
      return;
    }

    /* close an open quick-add panel when tapping elsewhere */
    if (!t.closest('.card__quick') && !t.closest('[data-quick-toggle]')) {
      $$('[data-quick-panel].is-open').forEach(function (p) {
        p.classList.remove('is-open');
        var b = $('[data-quick-toggle]', p.closest('.card'));
        if (b) b.setAttribute('aria-expanded', 'false');
      });
    }
  });

  doc.addEventListener('change', function (e) {
    var t = e.target;
    if (t.matches && t.matches('[data-sort-select]') && t.form) {
      t.form.submit();
      return;
    }
    if (t.matches && t.matches('[data-cart-page-qty]') && t.form) {
      var flag = doc.createElement('input');
      flag.type = 'hidden'; flag.name = 'update'; flag.value = 'Update';
      t.form.appendChild(flag);
      t.form.submit();
    }
  });

  window.addEventListener('pageshow', function (e) {
    if (e.persisted && doc.getElementById('CartDrawer')) refreshCart().catch(function () { /* ignore */ });
  });

  /* ------------------------------------------------------ bag timer (reservation) */
  var cartTimer = (function () {
    var KEY = 'nf_cart_timer_v1';
    var handle = null;
    var clearing = false;

    function read() {
      try {
        var raw = window.localStorage.getItem(KEY);
        var v = raw ? JSON.parse(raw) : null;
        return v && typeof v.start === 'number' ? v : null;
      } catch (e) { return null; }
    }
    function write(v) {
      try {
        if (v === null) window.localStorage.removeItem(KEY);
        else window.localStorage.setItem(KEY, JSON.stringify(v));
        return true;
      } catch (e) { return false; }
    }
    function itemCount() {
      var inner = $('[data-cart-drawer-inner]');
      var n = inner ? parseInt(inner.getAttribute('data-item-count'), 10) : NaN;
      if (isNaN(n)) { var c = $('[data-cart-count]'); n = c ? parseInt(c.textContent, 10) : 0; }
      return n || 0;
    }
    function fmt(sec) {
      var m = Math.floor(sec / 60), s = sec % 60;
      return (m < 10 ? '0' : '') + m + ':' + (s < 10 ? '0' : '') + s;
    }
    function stop() { if (handle) { window.clearInterval(handle); handle = null; } }

    function clearBag() {
      if (clearing) return;
      clearing = true;
      stop();
      postJSON('/cart/clear.js', { sections: SECTION, sections_url: window.location.pathname })
        .then(function (data) { write(null); if (!renderDrawer(data.sections)) return refreshCart(); })
        .catch(function () { /* ignore: the bag stays as it is */ })
        .then(function () {
          clearing = false;
          toast('Your bag was emptied because the timer ran out.');
          if (NF.onCartPage) window.location.reload();
        });
    }

    function tick() {
      var els = $$('[data-cart-timer]');
      var state = read();
      if (!els.length || !state) { stop(); return; }
      var minutes = parseInt(els[0].getAttribute('data-minutes'), 10) || 10;
      var total = minutes * 60;
      var left = Math.max(0, Math.ceil(total - (Date.now() - state.start) / 1000));
      els.forEach(function (el) {
        var label = $('[data-timer-label]', el);
        var value = $('[data-timer-value]', el);
        var bar = $('[data-timer-bar]', el);
        var ended = left === 0;
        el.hidden = false;
        el.classList.toggle('is-expired', ended);
        if (label) label.textContent = el.getAttribute(ended ? 'data-expired-text' : 'data-label-text') || label.textContent;
        if (value) { value.hidden = ended; value.textContent = fmt(left); }
        if (bar) bar.style.width = (left / total * 100) + '%';
      });
      if (left === 0) {
        stop();
        if (els[0].getAttribute('data-action') === 'clear') clearBag();
      }
    }

    /* fresh = true right after something was added to the bag */
    function sync(fresh) {
      var els = $$('[data-cart-timer]');
      if (itemCount() === 0) { write(null); stop(); return; }
      if (!els.length) { stop(); return; }
      var minutes = parseInt(els[0].getAttribute('data-minutes'), 10) || 10;
      var total = minutes * 60 * 1000;
      var keep = els[0].getAttribute('data-action') !== 'clear';
      var state = read();
      var age = state ? Date.now() - state.start : 0;
      /* restart when there is no timer yet, when something new was added after it ended,
         or when a visitor comes back long after it ended (keep mode only) */
      if (!state || (fresh && age >= total) || (keep && age >= total + 30 * 60 * 1000)) {
        if (!write({ start: Date.now() })) { els.forEach(function (el) { el.hidden = true; }); return; }
      }
      tick();
      if (!handle && read() && Date.now() - read().start < total) handle = window.setInterval(tick, 1000);
    }

    return { sync: sync };
  })();
  cartTimer.sync(false);

  /* ---------------------------------------------------------- product page */
  function initGallery(section) {
    var stage = $('[data-gallery-stage]', section);
    if (!stage) return { goToMedia: function () {} };
    var items = $$('[data-gallery-item]', stage);
    var thumbs = $$('[data-thumb]', section);
    var dots = $$('[data-gallery-dots] i', section);
    var ticking = false;

    function setActive(i) {
      thumbs.forEach(function (th, n) { th.setAttribute('aria-current', n === i ? 'true' : 'false'); });
      dots.forEach(function (d, n) { d.classList.toggle('is-on', n === i); });
    }
    function goTo(i, smooth) {
      var item = items[i];
      if (!item) return;
      if (stage.scrollTo) stage.scrollTo({ left: item.offsetLeft, behavior: smooth === false ? 'auto' : 'smooth' });
      else stage.scrollLeft = item.offsetLeft;
      setActive(i);
    }

    stage.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      window.requestAnimationFrame(function () {
        ticking = false;
        setActive(Math.round(stage.scrollLeft / (stage.clientWidth || 1)));
      });
    }, { passive: true });

    thumbs.forEach(function (th, i) { th.addEventListener('click', function () { goTo(i); }); });

    var start = 0;
    thumbs.forEach(function (th, i) { if (th.getAttribute('aria-current') === 'true') start = i; });
    if (start > 0) goTo(start, false);

    return {
      goToMedia: function (id) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].getAttribute('data-media-id') === String(id)) { goTo(i); return; }
        }
      }
    };
  }

  function initProduct(section) {
    var jsonEl = $('[data-product-json]', section);
    if (!jsonEl) return;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (err) { return; }

    var gallery = initGallery(section);
    var groups = $$('[data-option-group]', section);
    var idInput = $('[data-variant-id]', section);
    var priceEl = $('[data-price]', section);
    var addBtn = $('[data-add-btn]', section);
    var addLabel = $('[data-add-label]', section);
    var stockEl = $('[data-stock]', section);
    var stockText = stockEl && $('[data-stock-text]', stockEl);
    var pillEl = $('[data-price-pill]', section);
    var errorEl = $('[data-form-error]', section);
    var form = $('form[data-product-form]', section);
    var sticky = $('[data-sticky-atc]');
    var stickyBtn = $('[data-sticky-btn]');
    var stickyPrice = $('[data-sticky-price]');
    var stickyVariant = $('[data-sticky-variant]');
    var threshold = parseInt(section.getAttribute('data-low-stock-threshold'), 10) || 0;
    var current = null;

    function selectedOptions() {
      return groups.map(function (g) { var c = $('input:checked', g); return c ? c.value : null; });
    }
    function findVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var match = true;
        for (var j = 0; j < opts.length; j++) { if (variants[i].options[j] !== opts[j]) { match = false; break; } }
        if (match) return variants[i];
      }
      return null;
    }
    function setPrice(v) {
      if (!priceEl) return;
      priceEl.textContent = '';
      if (v.compare) { var s = doc.createElement('s'); s.textContent = v.compare; priceEl.appendChild(s); }
      var span = doc.createElement('span'); span.textContent = v.price; priceEl.appendChild(span);
    }
    function setButtons(v) {
      var available = !!(v && v.available);
      var label = v ? (available ? 'Add to cart' : 'Sold out') : 'Unavailable';
      [addBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = !available; });
      if (addLabel) addLabel.textContent = label;
      if (stickyBtn) stickyBtn.textContent = label;
    }
    /* green when plenty is left, red and blinking when it is running low, grey when sold out */
    function setStock(v) {
      if (!stockEl || !stockText) return;
      if (!threshold || !v || !v.managed) { stockEl.hidden = true; return; }
      var where = v.options.length && v.options[0] !== 'Default Title' ? ' in ' + v.options.join(' / ') : '';
      var state, text;
      if (!v.available) {
        state = 'out'; text = 'Sold out' + where;
      } else if (v.inventory > 0 && v.inventory <= threshold) {
        state = 'low'; text = 'Only ' + v.inventory + ' left' + where;
      } else {
        state = 'ok'; text = stockEl.getAttribute('data-ok-text') || 'In stock';
      }
      stockEl.setAttribute('data-state', state);
      stockText.textContent = text;
      stockEl.hidden = false;
    }
    function setPill(v) {
      if (!pillEl) return;
      if (v && v.pct > 0) { pillEl.textContent = v.pct + '% off'; pillEl.hidden = false; }
      else pillEl.hidden = true;
    }

    function update(fromUser) {
      current = groups.length ? findVariant(selectedOptions()) : variants[0];
      groups.forEach(function (g) {
        var em = $('[data-selected-value]', g);
        var checked = $('input:checked', g);
        if (em && checked) em.textContent = checked.value;
      });
      setButtons(current);
      setStock(current);
      if (errorEl) errorEl.hidden = true;
      if (!current) return;
      if (idInput) idInput.value = current.id;
      setPrice(current);
      setPill(current);
      if (stickyPrice) stickyPrice.textContent = current.price;
      if (stickyVariant && groups.length) stickyVariant.textContent = current.options.join(' / ');
      if (fromUser) {
        if (current.featured_media_id) gallery.goToMedia(current.featured_media_id);
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', current.id);
          window.history.replaceState({}, '', url.toString());
        } catch (err) { /* ignore */ }
      }
    }

    section.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('[data-option-group] input')) update(true);
    });
    update(false);

    /* ajax add to cart */
    if (form) {
      form.addEventListener('submit', function (e) {
        var submitter = e.submitter;
        if (submitter && !submitter.hasAttribute('data-add-btn') && !submitter.hasAttribute('data-sticky-btn')) return;
        if (!doc.getElementById('CartDrawer') || NF.onCartPage) return;
        if (!current || !current.available) { e.preventDefault(); return; }
        e.preventDefault();
        var qtyInput = $('[name="quantity"]', form);
        var qty = qtyInput ? Math.max(1, parseInt(qtyInput.value, 10) || 1) : 1;
        var previous = addLabel ? addLabel.textContent : '';
        [addBtn, stickyBtn].forEach(function (b) { if (b) b.disabled = true; });
        if (addLabel) addLabel.textContent = 'Adding…';
        if (errorEl) errorEl.hidden = true;
        addToCart(current.id, qty).then(function () {
          if (addLabel) addLabel.textContent = 'Added';
          window.setTimeout(function () { setButtons(current); }, 1200);
        }).catch(function (err) {
          if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          if (addLabel) addLabel.textContent = previous;
          setButtons(current);
        });
      });
    }

    /* sticky add to cart on small screens */
    if (sticky && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var entry = entries[0];
        sticky.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      }).observe(addBtn);
    }
  }

  $$('[data-product-section]').forEach(initProduct);

  /* ----------------------------------------------------- announcement bar */
  (function () {
    var bar = $('[data-announcement]');
    if (!bar) return;
    var msgs = $$('.announcement__msg', bar);
    if (msgs.length < 2) return;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var delay = parseInt(bar.getAttribute('data-speed'), 10) || 4000;
    var index = 0;
    var paused = false;
    var timer = null;

    function show(n) {
      msgs[index].classList.remove('is-active');
      index = n;
      msgs[index].classList.add('is-active');
    }
    function start() {
      if (timer) return;
      timer = window.setInterval(function () { if (!paused) show((index + 1) % msgs.length); }, delay);
    }
    function stop() {
      if (timer) { window.clearInterval(timer); timer = null; }
    }

    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    doc.addEventListener('visibilitychange', function () { if (doc.hidden) stop(); else start(); });
    start();
  })();

  /* ------------------------------------------------------------ email popup */
  function initPopup() {
    var dlg = $('[data-popup]');
    if (!dlg || typeof dlg.showModal !== 'function') return;
    var KEY = 'nf_popup_v1';
    var started = Date.now();

    function seen() { try { return !!window.localStorage.getItem(KEY); } catch (e) { return false; } }
    function mark() { try { window.localStorage.setItem(KEY, String(Date.now())); } catch (e) { /* ignore */ } }
    function show(force) {
      if (dlg.open) return;
      if (!force && seen()) return;
      if ($('.drawer.is-open') || $('[data-cookie-banner].is-open')) return;
      if (!force && cookieRecentlyClosed()) return;
      dlg.showModal();
      try { dlg.focus({ preventScroll: true }); } catch (e) { /* ignore */ }
      mark();
    }

    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-popup-close]')) { dlg.close(); return; }
      var cp = e.target.closest('[data-popup-copy]');
      if (cp) {
        var code = cp.getAttribute('data-popup-copy');
        var done = function () { cp.textContent = 'Copied'; window.setTimeout(function () { cp.textContent = 'Copy'; }, 2000); };
        try {
          if (navigator.clipboard && navigator.clipboard.writeText) { navigator.clipboard.writeText(code).then(done, function () {}); }
          else { var r = document.createRange(); r.selectNodeContents($('[data-popup-code]', dlg)); var sel = window.getSelection(); sel.removeAllRanges(); sel.addRange(r); done(); }
        } catch (err) { /* ignore */ }
      }
    });

    if (dlg.hasAttribute('data-posted')) { show(true); return; }
    if (seen()) return;

    var delay = Math.max(10, parseInt(dlg.getAttribute('data-delay'), 10) || 15) * 1000;
    var tries = 0;
    function attempt() {
      if (seen() || dlg.open) return;
      if (($('.drawer.is-open') || $('[data-cookie-banner].is-open') || cookieRecentlyClosed()) && tries < 40) { tries++; window.setTimeout(attempt, 1500); return; }
      show(false);
    }
    window.setTimeout(attempt, delay);

    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      doc.addEventListener('mouseout', function (ev) {
        if (!ev.relatedTarget && ev.clientY <= 0 && Date.now() - started > 8000) show(false);
      });
    }
  }
  initPopup();

  /* ------------------------------------------------------------ cookie banner */
  function initCookieBanner() {
    var box = $('[data-cookie-banner]');
    if (!box) return;
    var card = $('[data-cc-card]', box);
    var main = $('[data-cc-main]', box);
    var prefs = $('[data-cc-prefs-view]', box);
    var everywhere = box.getAttribute('data-everywhere') === 'true';
    var KEY = 'nf_cookie_v1';
    var shown = false;
    var lastFocus = null;

    function api() { return window.Shopify && window.Shopify.customerPrivacy; }
    function remembered() { try { return !!window.localStorage.getItem(KEY); } catch (e) { return false; } }
    function remember(v) { try { window.localStorage.setItem(KEY, v); } catch (e) { /* ignore */ } }

    function decided() {
      var p = api();
      if (p && typeof p.currentVisitorConsent === 'function') {
        var c = p.currentVisitorConsent() || {};
        if (c.analytics === 'yes' || c.analytics === 'no' || c.marketing === 'yes' || c.marketing === 'no' || c.preferences === 'yes' || c.preferences === 'no') return true;
      }
      return remembered();
    }
    function wanted() {
      if (decided()) return false;
      if (everywhere) return true;
      var p = api();
      return !!(p && typeof p.shouldShowBanner === 'function' && p.shouldShowBanner());
    }
    function open() {
      if (shown) return; /* our banner always wins: Shopify's own is hidden by CSS (sections/cookie-banner.liquid) */
      shown = true;
      lastFocus = doc.activeElement;
      box.hidden = false;
      root.classList.add('has-cc');
      window.requestAnimationFrame(function () { window.requestAnimationFrame(function () { box.classList.add('is-open'); }); });
      window.setTimeout(function () { if (card) card.focus({ preventScroll: true }); }, 60);
    }
    function close() {
      box.classList.remove('is-open');
      root.classList.remove('has-cc');
      cookieClosedAt = Date.now();
      window.setTimeout(function () { box.hidden = true; }, 280);
      if (lastFocus && lastFocus.focus) { try { lastFocus.focus({ preventScroll: true }); } catch (e) { /* ignore */ } }
    }
    function save(c) {
      var p = api();
      remember('set');
      if (p && typeof p.setTrackingConsent === 'function') {
        try { p.setTrackingConsent(c, function () {}); } catch (e) { /* ignore */ }
      }
      close();
    }
    function showPrefs() {
      if (!main || !prefs) return;
      main.hidden = true;
      prefs.hidden = false;
      var h = $('[data-cc-prefs-title]', prefs);
      if (h) h.focus({ preventScroll: true });
      if (card) card.scrollTop = 0;
    }

    box.addEventListener('click', function (e) {
      var t = e.target;
      if (t.closest('[data-cookie-accept]')) { save({ analytics: true, marketing: true, preferences: true }); return; }
      if (t.closest('[data-cookie-decline]')) { save({ analytics: false, marketing: false, preferences: false }); return; }
      if (t.closest('[data-cookie-save]')) {
        var pick = function (k) { var i = $('[data-cc-toggle="' + k + '"]', box); return !!(i && i.checked); };
        save({ analytics: pick('analytics'), marketing: pick('marketing'), preferences: pick('preferences') });
        return;
      }
      if (t.closest('[data-cc-prefs]')) showPrefs();
    });
    doc.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') { save({ analytics: false, marketing: false, preferences: false }); return; }
      if (e.key === 'Tab' && card) {
        var f = $$('button:not([disabled]), a[href], input:not([disabled])', card).filter(function (n) { return n.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && (doc.activeElement === first || doc.activeElement === card)) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && doc.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    });

    function start() { if (wanted()) window.setTimeout(open, 700); }
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      try {
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.2' }], function (err) {
          if (err && !everywhere) return;
          start();
        });
      } catch (e) { if (everywhere) start(); }
    } else if (everywhere) { start(); }
  }
  initCookieBanner();
})();
